export default __webpack_public_path__ + "static/media/general-booking.0a96b165.svg";